import { useContext, useRef } from 'react';
import { DiagnosticContext, useOutsideClick } from '../../helpers/functions';
import { getSuggestedTests } from '../../services/londi-suggestions';
import Select from '../select';

const ThirdTestOption = ({ thirdTestOptions, showState, showCategory, thirdTestId, thirdTestType, setChecked }) => {
  const { state, dispatch } = useContext(DiagnosticContext);
  const wrapperRef = useRef(null);
  useOutsideClick(wrapperRef);

  const newState = {
    ...state,
    screeningResultCounting: { category: 3, result: 1 },
    screeningResultReading: { category: 1, result: 1 },
    screeningResultWriting: { category: 2, result: 1 },
  };
  const suggestedOutput = getSuggestedTests(newState, false, false, true);
/*
  const selectedIds = () => {
    switch (showCategory) {
      case 1:
        return [state.readingTestId, state.readingSecondTestId];
      case 2:
        return [state.writingTestId, state.writingSecondTestId];
      case 3:
        return [state.countingTestId, state.countingSecondTestId];
      default:
        return [];
    }
  };
*/
  return (
    <Select
      onToggle={() => dispatch({ type: thirdTestOptions })}
      selected={makeOption()(showState)}
      setSelected={({ res }) => {
        dispatch({ type: thirdTestType, payload: res.shortName });
        dispatch({ type: thirdTestId, payload: res.id });
        setChecked(true);
      }}
      options={
        state?.options === thirdTestOptions
          ? suggestedOutput
              ?.filter((o) => o.category === showCategory)
              .flatMap((o) => o.allTests)
              .filter((o) => {
                // Filter out tests already selected in first position
                if (showCategory === 1) return o.id !== state.readingTestId;
                if (showCategory === 2) return o.id !== state.writingTestId;
                if (showCategory === 3) return o.id !== state.countingTestId;
                return true;
              })
              .map((o) => ({ id: o.id, name: o.shortName, res: o }))
          : []
      }
    />
  );
};

function makeOption(handler = (v) => v) {
  return (v) => {
    if (v == null) return undefined;
    return { id: v, name: handler(v) };
  };
}

export default ThirdTestOption;
